var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"main-app"}},[_c('div',{staticClass:"main"},[_c('user-header'),_c('main',{staticClass:"content",class:_vm.contentClasses},[(_vm.$route.meta.keepAlive)?_c('keep-alive',[_c('router-view',{key:_vm.$route.path})],1):_c('router-view',{key:_vm.$route.fullPath})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }